import React from 'react';
import { Card, Row, Col } from "reactstrap";
import avtarImage1 from "../../assets/images/users/avatar-1.jpg";
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';


const Workflow_GridView = ({delete_workflow}) => {
  const navigate = useNavigate()
const workflow_list = useSelector((state)=>{
   return state.WorkFlowBuilder.workflow_list
})


  return (
    <React.Fragment>
      <div
     
        className="botgrid">
        <Row className="row-cols-xxl-5 row-cols-lg-3 row-cols-1">
          
              {workflow_list?.data?.map((workflow , index)=>{
                
                return <Col  key={index} className="grid-wrap">
                <span className="gbd"> <i onClick={()=>{
                                                delete_workflow(workflow.Workflow_ID)
                                            }}className="ri-delete-bin-line"></i></span>
                   <Card onClick={()=>{
                    navigate("/workflow",{
                      state:{
                        Workflow_ID:workflow.Workflow_ID
                      }
                    })
                   }} className="card-body">
                     <div  className="d-flex mb-4 align-items-center">
                       <div  className="flex-shrink-0">
                         <img
                           src={workflow.Workflow_Logo}
                           alt=""
                           className="avatar-sm rounded-circle"
                         />
                       </div>
                       <div className="flex-grow-1 ms-2">
                         <h5 className="card-title mb-1">{workflow.Workflow_Title}</h5>
                       </div>
                     </div>
                     <div  className="grid_detail">
                       <p className="card-text text-muted"> {workflow.Group.Group_Name} </p>
                       <p className="card-text text-muted">{workflow.Category}</p>
                        {/* <p className="card-text text-muted">workflow.data.Type</p> */}
                       <p className="card-text text-muted"></p>
                       
                       <p className="card-text text-muted">
                            {moment(workflow.Created_At).format('YYYY-MM-DD')}
                       </p>
                      
                     </div>
                     
                   </Card>
                 </Col>
              } 
                )
}
                 
             
              
            
        </Row>
        
      </div>
    </React.Fragment>
  )
}

export default Workflow_GridView